<template>
  <div class='EnbMarketingGeral'>
    <pref-comp
    :label="Empresa.modelo !== 'Modelo 03' ? 'Frente de loja' : 'Frente de Site'"
    :sublabel="Empresa.modelo !== 'Modelo 03' ? 'Configure e ative ou desative a frente de loja' : 'Configure e ative ou desative a frente de site'"
    frenteloja
    frentelojaCorFundo
    frentelojaCorFonte
    slide
    slogan
    category
    />
    <enb-maps-nets/>
    <pref-comp
    label="Banners"
    sublabel="Lateral Loja - 200x200px"
    banner
    v-if="Empresa.modelo !== 'Modelo 03'"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PrefComp from '../Preferencia/PrefComp'
import EnbMapsNets from '../Preferencia/EnbMapsNets'
export default {
  name: 'EnbMarketingGeral',
  components: { PrefComp, EnbMapsNets },
  computed: {
    ...mapGetters(['Empresa'])
  }
}
</script>

<style scoped>
.EnbMarketingGeral {
  padding: 1%;
}
</style>
